module.exports = __webpack_public_path__ + "img/VinoTintoMonteabellon14meses.7125e48d.jpg";